import { Component, h, Prop, Event, EventEmitter } from "@stencil/core"

@Component({
  tag: "chatbot-history",
  styleUrl: "chat-history.css",
  shadow: true,
})
export class ChatbotHistory {
  private cdnPath: string = "https://cdn.ai12z.net/assets/bot"
  @Prop() chatList = []
  @Prop() botName: string = "AI12z Bot"
  @Prop() chatlogo: string = this.cdnPath + `/v1/ai12z-bot/img/chatbot.jpg`
  @Prop() heading: string = "Chat history"
  @Event() chatClick: EventEmitter
  @Event() deleteChatHistory: EventEmitter
  handleClick(chat: any) {
    this.chatClick.emit(JSON.parse(JSON.stringify(chat)))
  }

  deleteHistory(chat: any) {
    this.deleteChatHistory.emit(chat)
  }

  convertHtmlToPlainText(html: string) {
    var temp = document.createElement("div")
    temp.innerHTML = html
    return temp.textContent || temp.innerText || ""
  }

  sortByDateDesc() {
    return this.chatList.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
  }

  filterMessages(chat: any) {
    if (!chat?.messages) {
      return [] // Return empty array if no messages
    }

    return chat.messages.reduce((acc, message) => {
      if (message.isUser === true) {
        acc.push({ user: message.text })
      } else if (message.isUser === false) {
        acc.push({ agent: this.parseHtmlToText(message.text) })
      }
      return acc
    }, [])
  }

  parseHtmlToText(html: string): string {
    const parser = new DOMParser()
    // Parse the HTML string into a document
    const doc = parser.parseFromString(html, "text/html")
    // Get the text content from the document, stripping out the HTML tags
    return doc.body.textContent || ""
  }

  downloadChat(chat: any) {
    // console.log("*********", chat)
    const filteredMessages = this.filterMessages(chat)
    let transcriptText = new Date(chat.date).toLocaleString() + "\n" // Add a new line at the top
    // Create the text version of the chat
    transcriptText += filteredMessages
      .map(message => {
        if (message.user) {
          return `You: ${message.user}`
        } else if (message.agent) {
          return `Agent: ${message.agent}`
        }
      })
      .join("\n") // Join with a new line

    // Create a Blob for the text file
    const blob = new Blob([transcriptText], { type: "text/plain" })
    // Convert chat history to JSON string
    // const dataStr = JSON.stringify(filteredMessages, null, 2)

    // Create a Blob object
    // const blob = new Blob([dataStr], { type: "application/json" })

    // Create a link element
    const downloadLink = document.createElement("a")
    downloadLink.href = URL.createObjectURL(blob)

    downloadLink.download = `chat-${new Date(chat.date).getTime()}.txt` // Name of the file

    // Programmatically click the link to trigger download
    downloadLink.click()
  }

  render() {
    const sortedItems = this.sortByDateDesc()
    return (
      <div>
        <ul class="history-list">
          {sortedItems.length === 0 && <p class="no-history">No chat history available</p>}
          {sortedItems.map(chat => {
            return (
              <li class="conversation-list-item">
                <div class="conversation-list-item-body">
                  <div>
                    <img class="avatar" src={this.chatlogo} alt="Avatar" />
                  </div>
                  <div class="conversation-list-item-body-content">
                    {/* <h2>{this.botName} </h2> */}
                    <h2 onClick={() => this.handleClick(chat.messages)}>{new Date(chat.date).toLocaleString()}</h2>
                    <span class="conversation-list-item-time">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20px"
                        width="20px"
                        onClick={() => this.downloadChat(chat)}
                        style={{ "margin-right": "10px" }}
                      >
                        <path
                          opacity="0.5"
                          d="M3 15C3 17.8284 3 19.2426 3.87868 20.1213C4.75736 21 6.17157 21 9 21H15C17.8284 21 19.2426 21 20.1213 20.1213C21 19.2426 21 17.8284 21 15"
                          stroke="#1C274C"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path d="M12 3V16M12 16L16 11.625M12 16L8 11.625" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>{" "}
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 29" id="delete" height="20px" width="20px" onClick={() => this.deleteHistory(chat)}>
                        <path d="M10 3v3h9V3a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1z"></path>
                        <path d="M4 5v1h21V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1zM6 8l1.812 17.209A2 2 0 0 0 9.801 27H19.2a2 2 0 0 0 1.989-1.791L23 8H6zm4.577 16.997a.999.999 0 0 1-1.074-.92l-1-13a1 1 0 0 1 .92-1.074.989.989 0 0 1 1.074.92l1 13a1 1 0 0 1-.92 1.074zM15.5 24a1 1 0 0 1-2 0V11a1 1 0 0 1 2 0v13zm3.997.077a.999.999 0 1 1-1.994-.154l1-13a.985.985 0 0 1 1.074-.92 1 1 0 0 1 .92 1.074l-1 13z"></path>
                      </svg>
                    </span>
                    {/* <span class="conversation-list-item-time">{chat.date} </span> */}
                    <p class="conversation-list-item-last-message"> {this.convertHtmlToPlainText(chat.messages[0].text)} </p>
                  </div>
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    )
  }
}
